webpackJsonp([1],{

/***/ 24:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  methods: {
    switchLocale: function switchLocale(locale) {
      this.$i18n.locale = locale;
    }
  }
});

/***/ }),

/***/ 25:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(92);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'hello',
  data: function data() {
    return {
      msg: 'Welcome to Your Vue.js PWA',
      weightUnits: ['ounce', 'gram', 'kilogram'],
      weightUnit: 'kilogram',
      currencies: { 'USD': 1 },
      currency: 'USD',
      metals: __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].getCachedMetals()
    };
  },
  created: function () {
    var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].getMetals();

            case 2:
              this.metals = _context.sent;
              _context.next = 5;
              return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].getCurrencies(['EUR', 'USD', 'PLN']);

            case 5:
              this.currencies = _context.sent;

              setInterval(this.refreshMetals, 3000);
              setInterval(this.refreshCurrencies, 3000);

            case 8:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function created() {
      return _ref.apply(this, arguments);
    }

    return created;
  }(),
  methods: {
    refreshMetals: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].getMetals();

              case 2:
                this.metals = _context2.sent;

              case 3:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function refreshMetals() {
        return _ref2.apply(this, arguments);
      }

      return refreshMetals;
    }(),
    refreshCurrencies: function () {
      var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].getCurrencies(['EUR', 'USD', 'PLN']);

              case 2:
                this.currencies = _context3.sent;

              case 3:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function refreshCurrencies() {
        return _ref3.apply(this, arguments);
      }

      return refreshCurrencies;
    }()
  }
});

/***/ }),

/***/ 42:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_i18n__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(51);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_i18n__["a" /* default */]);

var messages = {
  en: {
    message: {
      title: 'Metal Prices',
      metal: 'Metal',
      time: 'Time',
      buy: 'Bid',
      sell: 'Ask',
      gold: 'Gold',
      silver: 'Silver',
      platinum: 'Platinum',
      palladium: 'Palladium',
      ounce: 'Ounce',
      gram: 'Gram',
      kilogram: 'Kilogram',
      phone: '+33144648020',
      phone_label: '+33 1 44 64 80 20'
    }
  },
  fr: {
    message: {
      title: 'Cours des métaux précieux',
      metal: 'Métal',
      time: 'Heure',
      buy: 'Demande',
      sell: 'Offre',
      gold: 'Or',
      silver: 'Argent',
      platinum: 'Platine',
      palladium: 'Palladium',
      ounce: 'Once',
      gram: 'Gramme',
      kilogram: 'Kilogramme',
      phone: '+33144648020',
      phone_label: '+33 1 44 64 80 20'
    }
  },
  pl: {
    message: {
      title: 'Ceny metali',
      metal: 'Metal',
      time: 'Czas',
      buy: 'Bid',
      sell: 'Ask',
      gold: 'Złoto',
      silver: 'Srebro',
      platinum: 'Platyn',
      palladium: 'Pallad',
      ounce: 'Uncja',
      gram: 'Gram',
      kilogram: 'Kilogram',
      phone: '+33482535699',
      phone_label: '+33 4 82 53 56 99'
    }
  },
  de: {
    message: {
      title: 'Metallpreise',
      metal: 'Metall',
      time: 'Zeit',
      buy: 'Gebot',
      sell: 'Verkauf',
      gold: 'Gold',
      silver: 'Silber',
      platinum: 'Platin',
      palladium: 'Palladium',
      ounce: 'Unze',
      gram: 'Gramm',
      kilogram: 'Kilogramm',
      phone: '+48789236502',
      phone_label: '+48 789 236 502'
    }
  }
};

function getLocale() {
  var userLang = navigator.language || navigator.userLanguage;
  userLang = userLang.split('-')[0];
  if (messages[userLang]) {
    return userLang;
  }
  return 'en';
}

// Create VueI18n instance with options
var i18n = new __WEBPACK_IMPORTED_MODULE_1_vue_i18n__["a" /* default */]({
  locale: getLocale(), // set locale
  messages: messages // set locale messages
});

var formatter = Intl.NumberFormat('fr');
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter('formatNumber', formatter.format);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter('evolution', function (value) {
  return value < 0 ? value : '+' + value;
});

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  i18n: i18n,
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_2__App__["a" /* default */] }
});

/***/ }),

/***/ 47:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(24);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_08f5dcf3_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(50);
function injectStyle (ssrContext) {
  __webpack_require__(48)
}
var normalizeComponent = __webpack_require__(23)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_08f5dcf3_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 48:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 50:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('header',[_c('div',{staticClass:"row-1"},[_c('img',{staticClass:"logo",attrs:{"src":'static/img/logo_'+_vm.$i18n.locale+'.svg',"alt":"SAAMP Logo"}})]),_vm._v(" "),_c('div',{staticClass:"row-2"},[_c('h1',[_vm._v(_vm._s(_vm.$t('message.title')))])])]),_vm._v(" "),_c('main',[_c('router-view')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 51:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_PriceTable__ = __webpack_require__(53);


// import Hello from '@/components/Hello'


__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'Hello',
    component: __WEBPACK_IMPORTED_MODULE_2__components_PriceTable__["a" /* default */]
  }]
}));

/***/ }),

/***/ 53:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PriceTable_vue__ = __webpack_require__(25);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7841d2bc_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PriceTable_vue__ = __webpack_require__(95);
function injectStyle (ssrContext) {
  __webpack_require__(54)
}
var normalizeComponent = __webpack_require__(23)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PriceTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7841d2bc_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PriceTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 54:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 92:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getMetals */
/* unused harmony export getCurrencies */
/* unused harmony export getCachedMetals */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);



var baseURL = 'https://api.saamp.com';

var getMetals = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
    var response, data, rates;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return fetch(baseURL + '/metals');

          case 2:
            response = _context.sent;
            _context.next = 5;
            return response.json();

          case 5:
            data = _context.sent;
            rates = data.rates;

            localStorage.setItem('metals', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(rates));
            return _context.abrupt('return', rates);

          case 9:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function getMetals() {
    return _ref.apply(this, arguments);
  };
}();

var getCurrencies = function () {
  var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(symbols) {
    var response, data, currencies, symbol;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return fetch(baseURL + '/currencies');

          case 2:
            response = _context2.sent;
            _context2.next = 5;
            return response.json();

          case 5:
            data = _context2.sent;
            currencies = data.currencies;

            currencies.USD = 1; // USD is the base currency

            if (symbols) {
              for (symbol in currencies) {
                if (symbols.indexOf(symbol) === -1) {
                  delete currencies[symbol];
                }
              }
            }

            return _context2.abrupt('return', currencies);

          case 10:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, this);
  }));

  return function getCurrencies(_x) {
    return _ref2.apply(this, arguments);
  };
}();

function getCachedMetals() {
  var json = localStorage.getItem('metals');
  if (json) {
    localStorage.removeItem('metals');
    return JSON.parse(json);
  }
  return [];
}

/* harmony default export */ __webpack_exports__["a"] = ({
  getMetals: getMetals,
  getCurrencies: getCurrencies,
  getCachedMetals: getCachedMetals
});

/***/ }),

/***/ 95:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"price-table-container"},[_c('div',{staticClass:"table-header"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-metal"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.weightUnit),expression:"weightUnit"}],staticClass:"weight",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.weightUnit=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.weightUnits),function(unit){return _c('option',{key:unit,domProps:{"value":unit}},[_vm._v("\n            "+_vm._s(_vm.$t('message.' + unit))+"\n          ")])}))]),_vm._v(" "),_c('div',{staticClass:"col-time"},[_vm._v(_vm._s(_vm.$t('message.time')))]),_vm._v(" "),_c('div',{staticClass:"col-price"},[_c('div',{staticClass:"currency"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.currency),expression:"currency"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.currency=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.currencies),function(rate,symbol){return _c('option',{key:symbol,domProps:{"value":symbol}},[_vm._v("\n              "+_vm._s(symbol)+"\n            ")])}))]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-half"},[_vm._v(_vm._s(_vm.$t('message.buy')))]),_vm._v(" "),_c('div',{staticClass:"col-half"},[_vm._v(_vm._s(_vm.$t('message.sell')))])])])])]),_vm._v(" "),_c('div',{staticClass:"table-body"},_vm._l((_vm.metals),function(metal){return _c('div',{key:metal.metal,staticClass:"row"},[_c('div',{staticClass:"col-metal"},[_c('div',{staticClass:"name"},[_vm._v("\n          "+_vm._s(_vm.$t('message.' + metal.metal.toLowerCase()))+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"change",class:{ negative: metal.percentChange < 0 }},[_vm._v("\n          "+_vm._s(_vm._f("evolution")((metal.percentChange.toFixed(2))))+"%\n        ")])]),_vm._v(" "),_c('div',{staticClass:"col-time"},[_vm._v("\n        "+_vm._s(metal.time)+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"col-bid"},[_vm._v("\n          "+_vm._s(_vm._f("formatNumber")((metal.bidRate[_vm.weightUnit] * _vm.currencies[_vm.currency]).toFixed(0)))+"\n      ")]),_vm._v(" "),_c('div',{staticClass:"col-ask"},[_vm._v("\n        "+_vm._s(_vm._f("formatNumber")((metal.askRate[_vm.weightUnit] * _vm.currencies[_vm.currency]).toFixed(0)))+"\n        ")])])})),_vm._v(" "),_c('a',{staticClass:"contact row",attrs:{"href":'tel:'+_vm.$t('message.phone')}},[_c('div',{staticClass:"label"},[_vm._v("Contact")]),_vm._v(" "),_c('div',{staticClass:"number"},[_c('img',{attrs:{"src":__webpack_require__(96)}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('message.phone_label')))])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 96:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/static/img/phone.e783e6b.png";

/***/ })

},[42]);


// WEBPACK FOOTER //
// static/js/app.3a8e93aa21fde7359092.js